import React from "react";
import css from "./HeaderView.module.css";
import SearchBtn from "./SearchBtn/SearchBtn";
import NavItem from "./NavItem/NavItem";
import Themer from "./Themer/Themer";
import {AppIcon} from "Components";
import {libexports} from "Resources";


export default function HeaderView(props){
    const {showLibs,searchable=true,themerShown}=props;
    const allShown=showLibs==="all";
    return (
        <header className={`${css.headerview} ${props.className||""}`}>
            <AppIcon labeled={false}/>
            {showLibs&&
                <nav className={css.navbar} style={{transition:(statics.fadeDuration-100)+"ms"}}>
                    {statics.libnames.map(libname=>{
                        const {id,name,docs,undertest}=libexports[libname];
                        return  (allShown||(!undertest))&&(
                            <NavItem
                                key={id} 
                                label={name||id}
                                href={docs?`#/${id}`:undefined}
                                undertest={undertest}
                                message={`
                                    this library is still under test and this website is a way to test the package 
                                    so please feel free to submit any issue you encounter to
                                    <a href="https://github.com/vritrajs/vritrajs.github.io/issues">GitHub</a>
                                `}
                            />
                        )
                    })}
                </nav>
            }
            {searchable&&<SearchBtn 
                searchBarShown={props.searchBarShown}
                onToggle={showLibs&&((searching)=>{
                    const navbar=document.querySelector(`.${css.navbar}`);
                    if(window.innerWidth>=567){
                        /* navbar.style.columnGap=searching?"3em":null; */
                    }
                    else{
                        navbar.style.opacity=searching?0:1;
                    }
                })}
            />}
            {themerShown&&<Themer/>}
        </header>
    )
}

const statics={
    ...SearchBtn.statics,
    libnames:Object.keys(libexports).sort((b,a)=>b<a?1:-1),
}
